import { useMemo } from "react";

export const useJobProgress = (job: any) => {
  const jobProgress = useMemo(() => {
    const calcEmployeeProgress = (job: any, staffMember: any) => {
      const start = new Date(job.quote?.startDate || job.startDate);
      const end = new Date(job.quote?.endDate || job.endDate);
      const now = new Date();
      const staffStatus = staffMember?.StaffByJob?.status;

      if (!start || !end) return 0;
      if (staffStatus === "assigned") return 0;
      if (staffStatus === "completed") return 100;
      if (now <= start) return 0;
      if (now >= end) return 100;

      const elapsed = now.getTime() - start.getTime();
      const total = end.getTime() - start.getTime();

      return Math.round((elapsed / total) * 100);
    };

    if (!job.staff?.length) return 0;
    const total = job.staff?.reduce((acc: number, member: any) => acc + calcEmployeeProgress(job, member), 0);
    return Math.round(total / job.staff.length);
  }, [job]);

  return { jobProgress };
};
